import React from "react";
import { useDispatch } from "react-redux";
import { Field } from "formik";

import { NoteInput } from "components/inputs/text-input";
import { removeReferralAction } from "app/main/referrals/actions/referrals.actions";
import Form from "components/form";
import ReferralWarningMessage from "app/main/referrals/components/referral-warning-message-alert";

const RemoveReferralForm = ({
  orgUnitId,
  referralId,
  schema,
  warningMessages,
  onSucceed,
  contentProps,
}) => {
  const dispatch = useDispatch();

  const handleSubmit = ({ referral }, { setSubmitting, setErrors }) => {
    const removeReferral = {
      referralId,
      removedReason: referral.removedReason,
    };

    dispatch(removeReferralAction(orgUnitId, removeReferral)).then(responds => {
      setSubmitting(false);
      if (responds.error !== true) {
        onSucceed(responds.payload);
      } else {
        setErrors(responds.payload);
      }
    });
  };

  const initialValues = schema.cast();

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitLabel="Remove"
      validationSchema={schema}
      variant="filled"
      contentProps={contentProps}
      content={() => (
        <>
          {/* Warning message about deletion being permanent */}
          <div style={{
            marginBottom: 16,
            padding: 12,
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: 4,
          }}
          >
            <strong>Warning:</strong> This action cannot be undone. The referral will be permanently removed.
          </div>

          <ReferralWarningMessage warningMessages={warningMessages} />
          <Field
            name="referral.removedReason"
            component={NoteInput}
            label="Reason for Removal"
            icon="message"
            required
            maxLength={500}
            helperText="Please provide a reason for removing this referral"
          />
        </>
      )}
    />
  );
};

export default RemoveReferralForm;
